import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { CredentialsID } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const emptyArray: [] = [];

export const jiraIntegrationServiceKeys: unknown[] = ['service', 'jira', 'integration'];

export const useGetIssueTypes = (
  credentialsID: CredentialsID | undefined,
  options?: IUseQueryOptionsExtended<string[] | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => jiraIntegrationServiceKeys.concat(credentialsID), [credentialsID]);

  const res = useEitherQuery(
    keys,
    () => {
      if (credentialsID) {
        return services2.jiraIntegrationService.getIssueTypes(credentialsID);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  return {
    ...res,
    issueTypes: res.data || emptyArray,
  };
};
